import {
  Card,
  CardContent,
  CardContentProps,
  CardHeader,
  CardHeaderProps,
  CardProps,
} from "@mui/material";

import React from "react";

export type WcCardProps = CardProps;
export type WcCardContentProps = CardContentProps;
export type WcCardHeaderProps = CardHeaderProps;

export const WcCard = ({ children, ...props }: WcCardProps) => (
  <Card {...props}>{children}</Card>
);

export const WcCardContent = ({ children, ...props }: WcCardContentProps) => (
  <CardContent {...props}>{children}</CardContent>
);

export const WcCardHeader = ({ ...props }: WcCardHeaderProps) => (
  <CardHeader {...props}></CardHeader>
);
